<template>
  <div class="user-list">
    <el-tabs v-model="searchParam.status" type="card" @tab-click="getList">
      <el-tab-pane label="上架" name="2"></el-tab-pane>
      <el-tab-pane label="下架" name="1"></el-tab-pane>
    </el-tabs>
    <div class="search-bar flex">
      <div class="left">
        <el-select v-model="searchParam.teach_uuid" placeholder="授课老师" clearable @clear="getList">
          <el-option v-for="item in teacherList" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
        </el-select>
        <el-input v-model="searchParam.keyword_search" placeholder="输入标题" clearable @clear="getList"></el-input>
        <el-button type="primary" @click="getList('clear')">查询</el-button>
      </div>
      <div class="right">
        <el-button v-if="isteacher" @click="toDetail()">新增考试</el-button>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="paper_id" label="id" fixed="left" width="120px"> </el-table-column>
        <el-table-column prop="title" label="考试名称" width="120px"> </el-table-column>
        <el-table-column prop="avatar" label="封面" width="120px">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.avatar"
              fit="contain"
              :preview-src-list="[scope.row.avatar]"
            >
            </el-image> </template
        ></el-table-column>

        <el-table-column prop="teacher_name" label="授课老师" width="120px"> </el-table-column>
        <el-table-column prop="duty_name" label="责任老师" width="120px"> </el-table-column>
        <el-table-column prop="course_name" label="关联课程" width="120px"> </el-table-column>

        <el-table-column prop="address" label="考试地点"> </el-table-column>
        <el-table-column prop="exam_time" label="考试时间"> </el-table-column>

        <el-table-column prop="create_time" label="创建时间" width="160"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button v-if="isteacher" class="mid-blue" @click="toDetail(scope.row)">编辑</el-button>
            <el-button class="mid-blue" @click="toAdd(scope.row)">考试情况</el-button>
            <el-button v-if="isteacher" class="mid-blue" @click="changeStatus(scope.row)">{{
              scope.row.status == 1 ? "上架" : "下架"
            }}</el-button>

            <el-button v-if="isteacher" class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { paperList, delPaper, paperStatus } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
import Utils from "@/jslibs/utils";
export default {
  mixins: [mixin],
  data() {
    return {
      loading: false,
      teacherList: [],
      searchParam: {
        keyword_search: "",
        status: "2",
        start_time: "",
        end_time: "",
      },
      tableData: [],
    };
  },
  computed: {
    isteacher() {
      const g = Utils.getCookie("X-Access-Group");
      return g != 927 && g != 952;
    },
  },
  mounted() {
    this.getList();
    this.getTeacher("");
  },
  methods: {
    changeStatus(row) {
      paperStatus(row.uuid).then((res) => {
        if (res) {
          this.getList();
        }
      });
    },
    getTeacher(keyword_search) {
      getTeacherList({ type: 1 }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toAdd(row) {
      console.log(row);
      this.$router.push({
        path: "/offline-detail",
        query: row,
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/offline-add",
        query: row,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    deleteItem(row) {
      this.$confirm("确定要删除该课程吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delPaper(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList(type) {
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        exam_type: 2,
      };
      this.loading = true;
      const res = await paperList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
